import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesIn } from './ITypeValidatesIn';

export class InValidator implements ValidatorInterface<ITypeValidatesIn> {
  name = 'In';

  friendlyName = 'One Of';

  arrayOnly = false;

  array = false;

  description = 'shared.properties.validators.in.description';

  types = ['String', 'Number', 'Option'];

  properties = {
    value: {
      friendlyName: 'shared.properties.validators.in.properties.friendlyName',
      default: [],
      type: 'Any',
      isArray: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'ArrayUnique',
          value: true,
        },
        {
          name: 'ArrayMin',
          value: 1,
        },
        {
          name: 'ArrayMax',
          value: 2 ** 6,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesIn) {
    type.addInValidator(this);
  }
}

const inValidator = new InValidator(undefined);

ValidatorRegistry.register(InValidator, inValidator.name);

export { inValidator };
